import axios, { resHandle } from "@/plugins/axios";


/**
 * @description 获取创建Oss的初始参数
 * @param vCom Vue组件
 */
const GetOssParams = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        const params: any = {
            params: {
                type: "model"
            }
        };
        axios.get("api/oss", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 模型试用
 * @param vCom Vue组件
 */
const PostModelTrial = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/model/predict", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 舌面脉症状搜索（模型试用页面）
 * @param vCom Vue组件
 */
const PostShemianmaiSousuo = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/model/sizhen/zzs", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};




export { GetOssParams, PostModelTrial, PostShemianmaiSousuo };
